import React, { useEffect, useState } from 'react';

const useRecipes = () => {
  const [recipes, setRecipes] = useState([]);
  let URL;
  URL = `${process.env.REACT_APP_API_URL}/recipe`;
   
  useEffect(()=>{
    fetch(URL)
    .then(res => res.json())
    .then(data => setRecipes(data))
  }, [])
  return [recipes, setRecipes];
};

export default useRecipes;